<template>
  <div class="block fixed lg:hidden inset-x-0 bottom-0 z-10  bg-white shadow py-1 border-t">
    <section id="bottom-navigation" class="">
      <div id="tabs" class="flex justify-between">
        <!--      <a href="/" class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">-->
        <!--        <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="fox" />-->
        <!--        <span class="tab tab-home block text-[10px]">Home</span>-->
        <!--      </a>-->
        <a href="/themenbezogenes-lernen" class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
          <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('themenbezogenes-lernen') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="themen" />
          <span class="tab tab-kategori block text-[10px]">Themen</span>
        </a>
        <a href="/pruefungen" class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
          <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('pruefungen') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="graduate" />
          <span class="tab tab-explore block text-[10px]">{{ __('exam.plural') }}</span>
        </a>
        <a href="/meine-pruefungen" class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
          <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('meine-pruefungen') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="continue" />
          <span class="tab tab-explore block text-[10px]">{{ __('test.index') }}</span>
        </a>
        <a href="/meine-fehler" class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
          <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('meine-fehler') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="redo" />
          <span class="tab tab-whishlist block text-[10px]">Wiederholen</span>
        </a>
        <a href=/info class="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center pt-2 pb-1">
          <icon class="w-10 h-6 mb-1 mx-auto" :class="isUrl('info') ? 'text-orange-500 fill-orange-500' : 'fill-secondary-500 group-hover:fill-secondary'" name="info" />
          <span class="tab tab-account block text-[10px]">Info</span>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon'
import DgvtLegal from './DgvtLegal'

export default {

  name: 'MobileTabs',

  components: {
    Icon,
    DgvtLegal
  },

  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>

<style scoped>

</style>
